import { disableReactDevTools } from '@fvilers/disable-react-devtools';
import {HashRouter} from 'react-router-dom';
import ReactDOM from 'react-dom/client';
import React from 'react';
import App from './App';

if (process.env.NODE_ENV === 'production') {
   disableReactDevTools();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <HashRouter>
        <App />
      </HashRouter>
  </React.StrictMode>
);